import { Record } from 'immutable';

const EventVendorSummaryRecord = Record({
  'eventId': null,
  'name': null,
  'startDate': null,
  'autoGenerated': false,
  'eventReferenceNumber': null,
  'endDate': null,
  'payStatus': null,

  'eventPartyId': null,
  'vendorName': null,
  'masterBillPaid': null,
  'currency': null,
  'dueAmount': null,
  'paymentAmount': null,
  'error': null
});

export class EventVendorSummary {
  eventId: number;
  name: string;
  startDate: string;
  endDate: string;
  autoGenerated: boolean;
  eventReferenceNumber: string;
  payStatus: string;

  eventPartyId: number;
  vendorName: string;
  masterBillPaid: boolean;
  currency: string;
  dueAmount: string;
  paymentAmount: string;
  isSelected: boolean;
  error: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-vendor-summary.ts